
import { useSelector, useDispatch } from 'react-redux';

const protocol = window.location.protocol;
//console.log(loginuser);

 const API_URL   = ''
 const IMAGE_URL = ''
 const API_URL_NEW = ''
 const themeDefault = 'dark'
 const BASE_PATH = '/'
//  const WEB_URL = 'https://superplayerauction.com/front'
 const WEB_URL = '/'
 const MAIN_URL_PATH = protocol
 const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

 const HEADER_GLOBAL = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
         "Authorization" : JSON.stringify([{'cid': 1,'aid': 0}])
       }
    }

 export { HEADER_GLOBAL,API_URL,IMAGE_URL, themeDefault, MAIN_URL_PATH, namesOfModes, API_URL_NEW, BASE_PATH ,WEB_URL}


